import React from 'react';

import { NAV_BUYING_TOOLS, NAV_MENUS } from '@/app/lcv/contents/top-navigation';
import { LogoIsuzu } from '@/components/layouts/header/logo-isuzu';
import { TopNavigationFilled } from '@/components/layouts/top-navigation/layouts/filled';
import { TopNavigationTransparent } from '@/components/layouts/top-navigation/layouts/transparent';

interface IProps {
  children?: React.ReactNode;
  isTransparent?: boolean;
}

const View: React.FunctionComponent<IProps> = (props: IProps) => {
  return (
    <>
      {props.isTransparent ? (
        <TopNavigationTransparent
          Logo={<LogoIsuzu />}
          vehicleType="lcv"
          items={NAV_MENUS}
        />
      ) : (
        <TopNavigationFilled
          Logo={<LogoIsuzu />}
          vehicleType="lcv"
          items={NAV_MENUS}
          buyingTools={NAV_BUYING_TOOLS}
        />
      )}

      {props.children}
    </>
  );
};
View.displayName = 'LCVLayout';
export default View;
